module.exports = __webpack_public_path__ + "img/43.473fc828.jpg";